// Generated color tokens
// This file is auto-generated. Do not edit manually.
// Fetched from Figma and transformed to TypeScript

type HexString = `#${string}`
type CssGlobals = '-moz-initial' | 'inherit' | 'initial' | 'revert' | 'revert-layer' | 'unset'
export type Color = CssGlobals | HexString | 'transparent' | 'currentcolor'

const definition = {
    accent01: '#FF7477',
    accent02: '#4FBFFF',
    accent03: '#00FFC5',
    accentDark01: '#313D5A',
    accentLight01: '#E7E247',
    accentLight02: '#F4AFB4',
    background: '#FFFFFF',
    backgroundContent: '#EDEFF1',
    backgroundEmphasis: '#DDE0E4',
    backgroundInvertedHighlighted: '#FFFFFF40',
    backgroundSecondary: '#F8F9F9',
    black: '#000000',
    border: '#DDE0E4',
    borderInverted: '#FFFFFF40',
    brand: '#1839A0',
    brandActive: '#4071F7',
    brandBackgroundInverted: '#0B1947',
    brandHighlighted: '#2950E3',
    brandSecondary: '#F4F8FF',
    brandSecondaryActive: '#D1E1FF',
    brandSecondaryHighlighted: '#E5EEFF',
    brandText: '#182447',
    current: 'currentcolor',
    danger: '#7D2521',
    dangerActive: '#C94039',
    dangerHighlighted: '#A83029',
    dangerSecondary: '#F8E8E7',
    dangerSecondaryActive: '#D36C68',
    dangerSecondaryHighlighted: '#E9ADAB',
    dangerText: '#591E1B',
    dimension: '#0078BD',
    dimensionActive: '#4FBFFF',
    dimensionHighlighted: '#009CF5',
    dimensionSecondary: '#E0F5FF',
    dimensionSecondaryActive: '#A9DFFE',
    dimensionSecondaryHighlighted: '#C7EBFF',
    dimensionText: '#054D76',
    metric: '#0A857D',
    metricActive: '#07CFC2',
    metricHighlighted: '#06B1A6',
    metricSecondary: '#D3FDF3',
    metricSecondaryActive: '#93FBE7',
    metricSecondaryHighlighted: '#B5FCEA',
    metricText: '#065652',
    shadow: '#11192899',
    success: '#397546',
    successActive: '#64BE79',
    successHighlighted: '#4D9B5F',
    successSecondary: '#E8FBED',
    successSecondaryActive: '#8DD7A3',
    successSecondaryHighlighted: '#B7ECC4',
    successText: '#28513B',
    text: '#111928',
    textInverted: '#F8F9F9',
    textInvertedSecondary: '#98AADD',
    textLink: '#1839A0',
    textLinkInverted: '#98AADD',
    textMuted: '#B2BAC2',
    textSecondary: '#6B7280',
    transparent: 'transparent',
    warning: '#876E2F',
    warningActive: '#EDCC74',
    warningHighlighted: '#C4A650',
    warningSecondary: '#FFF8E7',
    warningSecondaryActive: '#F6E3A7',
    warningSecondaryHighlighted: '#FFF3CD',
    warningText: '#59491D',
} satisfies Record<string, Color>

export const colors: { [K in keyof typeof definition]: Color } = definition
export type Colors = typeof colors
export type ColorToken = keyof typeof definition
export const isColorToken = (color?: string): color is ColorToken =>
    !!color && typeof color === 'string' && Object.keys(colors).includes(color)
